import script from "./PublicProfilesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicProfilesSection.vue?vue&type=script&setup=true&lang=js"

import "./PublicProfilesSection.vue?vue&type=style&index=0&id=4a4d0e76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4d0e76"]])

export default __exports__